import { render } from "./EdukLog.vue?vue&type=template&id=d3f1b056"
import script from "./EdukLog.vue?vue&type=script&lang=js"
export * from "./EdukLog.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__